import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BadgeList as Block } from "./BadgeListBlock";
import { defaultData } from "./BadgeListBlockDefaultData";
import { meta } from "./BadgeListBlockMetaData";

export const BadgeListBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-badge-list",
    size: 24,
  },
  defaultData,
  meta,
};
